module.exports = __webpack_public_path__ + "static/img/55-3.7accda7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/55-3.jpg
// module id = yHCC
// module chunks = 0